var render = function render(){var _vm=this,_c=_vm._self._c;return _c('no-icon-card',{class:{
    'highlighted': _vm.highlighted,
  },scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("\n    Explanation\n  ")]},proxy:true}])},[_vm._v(" "),_c('div',{staticClass:"rationale",domProps:{"innerHTML":_vm._s(_vm.rationale)}}),_vm._v(" "),_c('no-icon-card')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }